import { AnalyticsUiAction, AnalyticsUiSubject, analytics } from '@atlassian/temp-analytics';
import { useEffect, useState } from 'react';
import { useScreenVisibility } from './use-screen-visibility';

export const useTimeSpent = (source?: string) => {
  const isVisible = useScreenVisibility();

  const [startTime, setStartTime] = useState(Date.now());

  useEffect(() => {
    if (isVisible) {
      setStartTime(Date.now());

      return () => {
        const endTime = Date.now();
        const timeSpent = (endTime - startTime) / 60000;
        analytics.sendUIEvent({
          action: AnalyticsUiAction.EXIT,
          actionSubject: AnalyticsUiSubject.USER,
          attributes: {
            timeSpent: timeSpent,
            source: source,
          },
        });
      };
    }
  }, [isVisible]);
};
